import { htmlIded } from '../fun-js-lib/html'
import { showLoader } from '../pdfPrinter/loader'
import { savedJQuery } from './jquery'

export function initCalendar () {
  if (pageHasCalendar()) {
    let closedDates = JSON.parse(htmlIded('closed-dates').innerHTML)
    let openedDates = JSON.parse(htmlIded('opened-dates').innerHTML)
    let openSignedDates = JSON.parse(htmlIded('opened-signed-dates').innerHTML)
    let dateFormat = htmlIded('date-format').innerHTML

    savedJQuery('#date-search').datepicker({
      dateFormat,
      beforeShowDay: function (date) {
        console.log('some')
        let $a = [false, '', '']
        if (closedDates.includes(formatDate(date))) {
          $a = [true, 'highlightClosedDate', '']
        }
        if (openedDates.includes(formatDate(date))) {
          $a = [true, 'highlightNotSigned', '']
        }
        if (openSignedDates.includes(formatDate(date))) {
          $a = [true, 'highlightOpen', '']
        }
        return $a
      },
      onSelect: function () {
        showLoader()
        calendar().parentElement.submit()
      }
    })
  }
}

export function enableCalendar () {
}

export function disableCalendar () {
}

const calendar = () =>
  htmlIded('date-search')

const pageHasCalendar = () =>
  calendar() !== null

/**
 * @param {Date} date 
 */
function formatDate (date) {
  // Use french-canadian format 'fr-ca' to transform date into YYYY-MM-DD
  const format = new Intl.DateTimeFormat('fr-ca', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  })
  return format.format(date)
}